<script setup>
    import { ref, watchEffect } from 'vue';
    import { getFromAPI, getFullUrlWithFilters, buildPageFooter, isButtonDisabled } from '../functionCollection';
    import SearchFields from './SearchFields.vue';

    const props = defineProps(['fetchUrl']);
    const logList = ref(null);
    const columnsToFetch = ['Datum', 'Kategorie', 'Benutzer', 'Message', 'IP'];

    // for the page footer
    const currentPage = ref(1);
    const maxPageNumber = ref(1);
    const logsOnPage = ref(null);
    const footerPageNumbers = ref(new Array());

    const filtersAsString = ref('');
    const receivedFilterParameters = ref([]);
    const filterParameters = [
        {index: 'Benutzer', title: 'RE-Nummer', value: ''},
        {index: 'Datum', title: 'Datum', value: ''},
        {index: 'Kategorie', title: 'Kategorie', value: ''},
        {index: 'Message', title: 'Message', value: ''},
        {index: 'IP', title: 'IP-Adresse', value: ''},
    ];

    watchEffect(async () => {
        const url = getFullUrlWithFilters(props.fetchUrl, currentPage.value, columnsToFetch, filtersAsString.value);
        logList.value = await getFromAPI(url);
        maxPageNumber.value = logList.value.meta.last_page;
        logList.value = logList.value.data;
        logsOnPage.value = logList.value.length;
        footerPageNumbers.value = buildPageFooter(currentPage.value, maxPageNumber.value);
    });

    // calls new suspendedUsers page whenever a page change is requested (i.e. a page button is pressed in the footer)
    async function getNewPage(newPage) {
        currentPage.value = newPage;
        if (currentPage.value < 1) {
            currentPage.value = 1;
        }
        logList.value = await getFromAPI(getFullUrlWithFilters(props.fetchUrl, currentPage.value, columnsToFetch, filtersAsString.value));
        maxPageNumber.value = logList.value.meta.last_page;
        logList.value = logList.value.data;
        logsOnPage.value = logList.value.length;
        buildPageFooter(currentPage.value, maxPageNumber.value);
    }

    // builds search query URL parameters, removing empty fields from query, and executes the search.
    function filterSearch(givenFields) {
        receivedFilterParameters.value = [];
        for (let i = 0; i < givenFields.length; i++) {
            if (givenFields[i].value !== null) {
                receivedFilterParameters.value.push(givenFields[i]);
            }
        }
        filtersAsString.value = JSON.stringify(receivedFilterParameters.value);
        getNewPage(1);
    }

</script>

<template>
    <SearchFields
        :fields="filterParameters"
        @filters="filterSearch"
    />

    <div class="main-table" v-if="logList && logList.length > 0">
        <div class="inner-table">
            <table class="table">
                <thead>
                    <tr>
                        <th class="table-head">Datum</th>
                        <th class="table-head">Kategorie</th>
                        <th class="table-head">Benutzer</th>
                        <th class="table-head">Message</th>
                        <th class="table-head">IP</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="log of logList" :key="log.id" class="m-datatable__row">
                        <td>{{ log.Datum }}</td>
                        <td>{{ log.Kategorie }}</td>
                        <td>{{ log.Benutzer }}</td>
                        <td>{{ log.Message }}</td>
                        <td>{{ log.IP }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div class="table-footer middle" v-if="logList && logList.length > 0 && footerPageNumbers.length > 1">
        <ul class="pagination">
            <li class="page-item">
                <button class="page-link" :disabled="isButtonDisabled('start')" @click="getNewPage(currentPage - 1)">
                    <i class="fas fa-lg fa-caret-left"></i>
                </button>
            </li>
            <li v-for="page in footerPageNumbers" :key="page.id" :class="{ 'active' : page == currentPage }" >
                <button class="page-link" @click="getNewPage(page)" :disabled="isButtonDisabled(page)">{{ page }}</button>
            </li>
            <li class="page-item">
                <button class="page-link" @click="getNewPage(currentPage + 1)" :disabled="isButtonDisabled('end')">
                    <i class="fas fa-lg fa-caret-right"></i>
                </button>
            </li>
        </ul>
    </div>

    <div class="m-3" v-if="logList && (logList.length == 0 || logList == null)">
        <div class="alert alert-custom" role="alert">
            <i class="fa-solid fa-comment fa-4x"></i>
            <span>Es konnten keine Logs gefunden werden.</span>
        </div>
    </div>

</template>
